import { makeStyles, createStyles } from '@material-ui/core/styles';

import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles(theme =>
  createStyles({
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: colors.primary,
      display: 'flex',
      justifyContent: 'center',
    },
    toolbar: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    menuGroup: {
      display: 'flex',
      alignItems: 'center',
    },
    menuButton: {
      marginRight: '20px',
    },
    logo: {
      marginRight: '18px',
    },
    pageTitle: {
      color: colors.white,
      fontSize: fonts.sizes.large,
      letterSpacing: '0.15px',
      marginLeft: '10px',
      lineHeight: '24px',
      fontWeight: fonts.weights.medium,
    },
    icon: {
      fontSize: fonts.sizes.large,
    },
    divider: {
      height: 20,
      marginRight: 0.5,
      background: 'white',
    },
    button: {
      margin: theme.spacing(0, 1),
    },
    userInfo: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginRight: theme.spacing(2),
      textAlign: 'right',
      fontSize: fonts.sizes.small,
      lineHeight: '14px',
    },
    userName: {
      letterSpacing: '0.15px',
      fontWeight: fonts.weights.bold,
      marginBottom: 4,
    },
  }),
);

export default useStyles;
